import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useTranslation } from 'react-i18next';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { getNote } from '../../organisms-cms/child-bio/utils/childNote.tsx';
import { getAge } from '../../utils/child-bio.ts';
type ChildBioInfoProps = {
  details: ChildDetails;
  note?: string;
  age: string;
  countryKey: string;
};
const ChildBioInfoList = t0 => {
  const $ = _c(59);
  const {
    details,
    note,
    age,
    countryKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("bio:age");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="label-xl label-potent ChildBioDetails__label">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== age || $[6] !== t3) {
    t4 = <p>{t3}{age}</p>;
    $[5] = age;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("bio:birthday");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="label-xl label-potent ChildBioDetails__label">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== details.birthDate || $[13] !== t) {
    t7 = new Date(details.birthDate || "").toLocaleDateString(t("bio:localeFormat"), {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    $[12] = details.birthDate;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== details.isBirthDateEstimated || $[16] !== t) {
    t8 = details.isBirthDateEstimated && t("bio:estimatedBirthday");
    $[15] = details.isBirthDateEstimated;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <p>{t6}{t7}{t8}</p>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("bio:gender");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = <span className="label-xl label-potent ChildBioDetails__label">{t10}</span>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== details.gender || $[27] !== t) {
    t12 = t("bio:genders", {
      context: details.gender.toString()
    });
    $[26] = details.gender;
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <p>{t11}{t12}</p>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = t("bio:location");
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14) {
    t15 = <span className="label-xl label-potent ChildBioDetails__label">{t14}</span>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const t16 = countryKey as unknown as TemplateStringsArray;
  let t17;
  if ($[36] !== t || $[37] !== t16) {
    t17 = t(t16);
    $[36] = t;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t15 || $[40] !== t17) {
    t18 = <p>{t15}{t17}</p>;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("bio:localId");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t19) {
    t20 = <span className="label-xl label-potent ChildBioDetails__label">{t19}</span>;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== details.localId || $[47] !== t20) {
    t21 = <p>{t20}{details.localId}</p>;
    $[46] = details.localId;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== note || $[50] !== t) {
    t22 = note && <p><span className="label-xl label-potent ChildBioDetails__label">{t("bio:note", {
          interpolation: {
            escapeValue: false
          }
        })}</span>{note}</p>;
    $[49] = note;
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t13 || $[53] !== t18 || $[54] !== t21 || $[55] !== t22 || $[56] !== t4 || $[57] !== t9) {
    t23 = <div className="ChildBioInfo ChildBioInfo--list">{t4}{t9}{t13}{t18}{t21}{t22}</div>;
    $[52] = t13;
    $[53] = t18;
    $[54] = t21;
    $[55] = t22;
    $[56] = t4;
    $[57] = t9;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  return t23;
};
const ChildBioInfoIcons = t0 => {
  const $ = _c(32);
  const {
    details,
    age,
    countryKey
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    gender
  } = details;
  const t2 = gender === ChildGenderEnum.Male ? "boy" : "girl";
  let t3;
  if ($[1] !== t2) {
    t3 = <ArkIcon iconName={t2} width="24px" height="24px" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== age || $[4] !== gender || $[5] !== t) {
    t4 = t("bio:yearsOldGender", {
      age,
      gender: t("bio:genders", {
        context: gender.toString()
      })
    });
    $[3] = age;
    $[4] = gender;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== details.isBirthDateEstimated || $[8] !== t) {
    t5 = details.isBirthDateEstimated && <span className="block">{t("bio:estimatedBirthday")}</span>;
    $[7] = details.isBirthDateEstimated;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <p className="ChildBioDetails__info ChildBioDetails__info--age label-sm label-moderate text-center">{t4}{t5}</p>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="ChildBioDetails__item flex flex-col items-center gap-snug-md">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArkIcon iconName="birthday-cake" width="24px" height="24px" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== details.birthDate || $[18] !== t) {
    t9 = new Date(details.birthDate || "").toLocaleDateString(t("bio:localeFormat"), {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    $[17] = details.birthDate;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="ChildBioDetails__item flex flex-col items-center gap-snug-md">{t8}<p className="ChildBioDetails__info label-sm label-moderate text-center">{t9}</p></div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ArkIcon iconName="globe-05" width="24px" height="24px" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = countryKey as unknown as TemplateStringsArray;
  let t13;
  if ($[23] !== t || $[24] !== t12) {
    t13 = t(t12);
    $[23] = t;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <div className="ChildBioDetails__item flex flex-col items-center gap-snug-md">{t11}<p className="ChildBioDetails__info label-sm label-moderate text-center">{t13}</p></div>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14 || $[30] !== t7) {
    t15 = <div className="ChildBioInfo ChildBioInfo--icons flex gap-comfy-xs justify-around py-comfy-xs">{t7}{t10}{t14}</div>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t7;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};
export const ChildBioInfo = t0 => {
  const $ = _c(13);
  const {
    details,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    ageInYearsAndMonths,
    country,
    localId
  } = details;
  let t2;
  if ($[0] !== ageInYearsAndMonths) {
    t2 = getAge(ageInYearsAndMonths);
    $[0] = ageInYearsAndMonths;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const age = t2;
  let t3;
  if ($[2] !== details) {
    t3 = getNote(details);
    $[2] = details;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const note = t3;
  let t4;
  if ($[4] !== country || $[5] !== localId) {
    t4 = countryToIso(country, localId);
    $[4] = country;
    $[5] = localId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const countryIso = t4;
  const countryKey = `geo:countries.${countryIso}.nameS`;
  const Component = variant === "icons" ? ChildBioInfoIcons : ChildBioInfoList;
  let t5;
  if ($[7] !== Component || $[8] !== age || $[9] !== countryKey || $[10] !== details || $[11] !== note) {
    t5 = <Component details={details} note={note} age={age} countryKey={countryKey} />;
    $[7] = Component;
    $[8] = age;
    $[9] = countryKey;
    $[10] = details;
    $[11] = note;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};